import { render, staticRenderFns } from "./pacientes_teste.vue?vue&type=template&id=17e85b4a&scoped=true"
import script from "./pacientes_teste.vue?vue&type=script&lang=js"
export * from "./pacientes_teste.vue?vue&type=script&lang=js"
import style0 from "./pacientes_teste.vue?vue&type=style&index=0&id=17e85b4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e85b4a",
  null
  
)

export default component.exports